import { CommonModule } from '@angular/common';
import { Component, Inject, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, Observable, of, switchMap } from 'rxjs';
import { CRMApiService } from '@vendasta/crm';
import { MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/meeting-analysis/static';
import { map } from 'rxjs/operators';
import { RouterModule } from '@angular/router';
import { ParticipantComponent } from './participant/participant.component';

@Component({
  selector: 'meeting-analysis-participants',
  imports: [CommonModule, RouterModule, ParticipantComponent],
  templateUrl: './participants.component.html',
  styleUrls: ['./participants.component.scss'],
})
export class ParticipantsComponent {
  contactIds = input<string[]>([]);
  large = input<boolean>(false);
  contacts$ = combineLatest([this.namespace$, toObservable(this.contactIds)]).pipe(
    switchMap(([namespace, contactIds]) => {
      if (contactIds.length === 0) {
        return of(null);
      }
      return this.contactService.getMultiContact({
        namespace: namespace,
        crmObjectIds: contactIds,
      });
    }),
    map((response) => response?.crmObjects || []),
  );

  constructor(
    private readonly contactService: CRMApiService,
    @Inject(MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$) private readonly namespace$: Observable<string>,
  ) {}
}
